<template>
  <el-card>
    <div class="pageTitle">设置商品介绍视频</div>
    <div class="productInfoContainer" v-if="activeStep != 0">
      <el-image
        class="productImg"
        :src="$route.query.imageUrl|| goodsInfo.imageUrl"
        fit="cover"
      ></el-image>
      <div class="productInfo" v-if="activeStep != 0">
        <div>
          <span class="productInfo_label">商品ID: </span>
          <span class="productInfo_value">{{ $route.query.id|| goodsInfo.id}}</span>
        </div>
        <div>
          <span class="productInfo_label">商品名称: </span>
          <span class="productInfo_value">{{ $route.query.name|| goodsInfo.name }}</span>
        </div>
      </div>
    </div>
    <div class="progressBarBox">
      <ProgressBar :steps="steps" :activeStep="activeStep" />
    </div>
    <!-- 第0步 选择商品-->
    <ShopListVue v-if="activeStep === 0"  @addGoods="addGoods"/>
    <!-- 第一步 选择数字人-->
    <DigitalHuman v-if="activeStep === 1" @select="selectDigitalHuman" @back='back' />
    <!-- 第二步 设置数字人形象-->
    <DigitalHumanAppearance
      v-if="activeStep === 2"
      :defaultFormVal="defaultFormVal"
      :defaultOtherParams="defaultOtherParams"
      :productId='goodsInfo.id'
      @prev="handleToFirstStep"
      @save="handleSave"
    />
    <!-- 第三步 查看结果 -->
    <div v-if="activeStep === 3" class="success-box">
      <SuccessStep :type="successType" />
    </div>
  </el-card>
</template>
<script>
import DigitalHuman from "./components/digitalHuman";
import DigitalHumanAppearance from "./product/components/digitalHumanAppearance";
import ProgressBar from "./product/components/progressBar";
import SuccessStep from "./product/components/successStep";
import ShopListVue from './product/components/shopList.vue'
import {
  queryVideoProgressInfo,
  digitalHumanPage,
} from "@/assets/api/aiProduct";
export default {
  components: {
    DigitalHuman,
    DigitalHumanAppearance,
    ProgressBar,
    SuccessStep,
    ShopListVue
  },
  data() {
    return {
      goodsInfo:{},
      steps: ["选择商品","选择AI数字人", "设置数字人形象", "查看渲染效果",],
      // 当前步骤位置
      successType: "draft",
      // 其他参数
      defaultOtherParams: {
        // 默认背景图
        defaultBg:
          "https://image2.soole.com.cn/slb-picture2025051316363046226.jpg",
        // 是否默认
        isDefaultBg: true,
        // 播报内容 文字 1  音频 2
        textType: 1,
        // 数字人形象
        aiImage: "",
        // 播报文件filename
        audioFileName: "",
      },
      activeStep:+this.$route.query.type - 1,
      defaultFormVal: {
        // 数字人code
        code: "",
        // 数字人背景图片
        backgroundImageUrl: "",
        // （注：3D视频全支持，2D视频只支持3、4）
        // 生成视频分辨率，生成的视频分辨率必须要与背景图片的分辨率保持一致
        //  目前支持：
        // 1：720 * 1280（竖屏）2：1280 * 720（横屏）3：1080 * 1920（竖屏）4：1920 * 1080（横屏）
        resolution: 3,
        // 字幕
        subtitleEmbedded: false,
        // 字体颜色，十六进制颜色码 RGBA。(subtitleEmbedded为true时，此字段必传)
        subtitleColor: "",
        // 字体名称(subtitleEmbedded为true时，此字段必传)
        subtitleName: "",
        // 字体描边颜色，十六进制颜色码 RGBA。(subtitleEmbedded为true时，此字段必传)
        subtitleOutlineColor: "",
        // 字体大小，最小值：36，最大值：72，默认值：36。(subtitleEmbedded为true时，此字段必传)
        subtitleSize: 36,
        // 任务类型，1 表示 3D 数字人视频合成，3 表示 2D 数字人视频合成
        taskType: 3,
        // (音频合成视频时，此字段必传)音频的地址 url，要求音频时长小于 30 分钟，采样率 16K，单声道，单采样点位深 16bit 可访问的公网url地址
        // 音频文件url
        url: "",
        // 播报内容，最长不超过 1000 个字符
        text: "",
        // 播报语速，
        // 取值范围：-500～500，[-500, 0, 500]
        // 对应的语速倍速区间为 [0.5, 1.0, 2.0]计算方法如下：
        // 0.8 倍速（1-1/0.8)/0.002 = -1251.2 倍速（1-1/1.2)/0.001 = 166
        speechRate: 0,
      },
    };
  },
  mounted() {
    this.activeStep = +this.$route.query.type - 1;
    // 在第二步就是有数据要查询草稿数据
    if (this.$route.query.type == "3") {
      this.getInfo();
    }
  },
  methods: {
    /**
     * 获取商品详情信息
     */
    getInfo() {
      queryVideoProgressInfo({
        bizId: +this.$route.query.id,
        bizType: 1,
      }).then((res) => {
        if (res.data) {
          const data = res.data;
          Object.keys(this.defaultFormVal).forEach((item) => {
            this.defaultFormVal[item] = data[item];
          });
          if (data.url) {
            this.defaultOtherParams.audioFileName = "音频文件";
            this.defaultOtherParams.textType = 2;
            this.defaultFormVal.subtitleEmbedded = false;
          }
          if (data.backgroundImageUrl !== this.defaultOtherParams.defaultBg) {
            this.defaultOtherParams.isDefaultBg = false;
          }

          digitalHumanPage({
            createdTime: "",
            modelType: "2d",
            pageNo: 1,
            pageSize: 200,
          }).then((res) => {
            if (res.data) {
              const aiPeople = res.data.records.find(
                (item) => item.code == this.defaultFormVal.code
              );
              this.defaultOtherParams.aiImage = aiPeople.image;
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    back(){
      this.activeStep = 0;
    },
    /** 选择数字人完成 */
    selectDigitalHuman(item) {
      this.activeStep = 2;
      this.defaultFormVal.code = item.code;
      this.defaultOtherParams.aiImage = item.image;
    },
    addGoods(infos){
      this.activeStep = 1;
      this.goodsInfo = infos
    },
    /** 前往上一步 */
    handleToFirstStep(formVal, otherParamsVal) {
      this.defaultFormVal = formVal;
      this.defaultOtherParams = otherParamsVal;
      this.activeStep = 1;
    },
    /**
     * 保存并前往第三步
     */
    handleSave(val) {
      this.activeStep = 3;
      this.successType = val.type;
    },
  },
};
</script>
<style scoped>
.progressBarBox {
  margin-bottom: 30px;
}

.pageTitle {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 20px;
}

.productInfoContainer {
  display: flex;
  margin-bottom: 20px;
}

.productImg {
  width: 80px;
  height: 80px;
}

.productInfo {
  margin-left: 27px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 60px;
  color: #787878;
  font-size: 14px;
}

.productInfo_label {
  color: #000000;
  font-weight: 600;
}

.success-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 200px;
  margin-bottom: 200px;
}
</style>
